const menuFooter = [
    {
        title: 'Частным лицам',
        slug: 'for-individuals',
        subMenu: [
            {
                title: 'Кредитование',
                slug: 'crediting',
            },
            {
                title: 'Ипотека',
                slug: 'mortgage',
            },
            {
                title: 'Вклады',
                slug: 'deposits',
            },
            {
                title: 'Карты',
                slug: 'cards',
                path: '/for-individuals/cards/debet-cards',
            },
            {
                title: 'VIP-обслуживание',
                slug: 'vip-service',
            },
            {
                title: 'Сервис Интернет-Банк',
                slug: 'internet-bank-service',
            },
            {
                title: 'Мобильный банк',
                slug: 'mobile-bank',
            },
        ],
    },
    {
        title: 'Бизнесу',
        slug: 'business',
        subMenu: [
            {
                title: 'Открытие и ведение счета',
                slug: 'opening-and-maintaining-account',
            },
            {
                title: 'Кредитование',
                slug: 'business-crediting',
            },
            {
                title: 'Эквайринг',
                slug: 'acquiring',
            },
            {
                title: 'Прием платежей',
                slug: 'accepting-payments',
                path: '/business/acquiring',
            },
            {
                title: 'Зарплатные проекты',
                slug: 'salary-projects',
            },
            {
                title: 'Депозиты',
                slug: 'placement-of-funds-and-securities',
            },
            {
                title: 'Самозанятым',
                slug: 'self-employed',
            },
            {
                title: 'Банковские гарантии',
                slug: 'bank-guarantees',
            },
        ],
    },
    {
        title: 'О банке',
        slug: 'about',
        subMenu: [
            {
                title: 'Контакты',
                slug: 'contacts',
            },
            {
                title: 'Акционерам и инвесторам',
                slug: 'investors',
            },
            {
                title: 'Офисы и банкоматы',
                slug: 'offices-and-atms',
            },
        ],
    },
    {
        title: 'Социальные проекты',
        slug: 'social-projects',
        subMenu: [
            {
                title: 'Медицинским работникам',
                slug: 'medical-professionals',
            },
            {
                title: 'Студентам',
                path: '/for-individuals/cards/student-cards',
            },
            {
                title: 'Пенсионерам',
                path: '/for-individuals/cards/debet-cards/pens',
            },
            {
                title: 'Финансовая грамотность',
                path: 'https://xn----7sbbzgbvlb6b9j.xn--p1ai/',
                isExternal: true,
            },
            {
                title: 'Карьера',
                slug: 'career',
            },
        ],
    },
    {
        title: 'esg',
        slug: 'esg',
        isEcoPage: true,
        icon: 'green-vector.svg',
        subMenu: [
            {
                title: 'Зелёный вклад',
                path: '/for-individuals/deposits/green',
                slug: 'green-products',
                green: true,
                isExternal: true,
            },
            {
                title: 'Зелёная ипотека',
                path: '/for-individuals/mortgage/green-mortgage',
                slug: 'green-mortgage',
                green: true,
                isExternal: true,
            },
            {
                title: 'Зелёный вектор',
                path: 'https://greenvector.media',
                slug: 'greenvector',
                isExternal: true,
            },
            {
                title: 'Социальный вклад банка',
                path: '/about#about-bank-social',
                slug: 'social-contribution',
                isExternal: true,
            },
            {
                title: 'ESG-библиотека',
                path: '/esg/esg-library',
                slug: 'esg-library',
                isExternal: true,
            },
        ],
    },
];

export {
    menuFooter,
};
